
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-forestry",
      function () {
        return require("private-next-pages/about-forestry/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-forestry"])
      });
    }
  